module.exports = __webpack_public_path__ + "static/media/nagi_topfc6abdf751c4ece316ef7537179ff5bd.webp";